<template>
  <div>Umleitung folgt...</div>
</template>

<script>
export default {
  name: "Home",
  data() {
    return {}
  },
  mounted() {
    this.redirect();
  },
  methods: {
    redirect() {
      this.$router.push(this.$router.resolve({name: "Home"}).route.path);
    }
  }
}
</script>

<style scoped>
.v-parallax__image {
  transform: none !important;
  width: 100% !important;
}

.action {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
}
</style>